"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  init: function init() {
    // JavaScript to be fired on the home page
  },
  finalize: function finalize() {
    // JavaScript to be fired on the home page, after the init JS
  }
};


// WEBPACK FOOTER //
// ./scripts/routes/home.js